import axios from '../axios'

/*
 *  等级信息
 */

export const selectByPage = (data) => {
    return axios({
        url: '/level/selectByPage',
        method: 'post',
        data
    })
}

export const insert = (data) => {
    return axios({
        url: '/level/insert',
        method: 'post',
        data
    })
}
export const update = (data) => {
    return axios({
        url: '/level/update',
        method: 'post',
        data
    })
}


export const batchSave = (data) => {
    return axios({
        url: '/level/batchSave',
        method: 'post',
        data
    })
}
export const refreshCompute = (params) => {
    return axios({
        url: '/level/refreshCompute',
        method: 'get',
        params
    })
}






// WEBPACK FOOTER //
// ./src/http/app/level.js